import * as Enumerable from "linq"
import {LookupValue } from "../../../../models/lookups/lookup.models";

export class GetUsersByDepartmentValueConverter {
    public toView(users: LookupValue[], selectedDepartmentId: number): LookupValue[] {
        if (users && selectedDepartmentId) {
            return Enumerable.from(users)
                .where(x => x.additionalData["departmentId"] ==
                    selectedDepartmentId).toArray();
        } else {
            return [];
        }
    }
}
